import ctl from '@netlify/classnames-template-literals'
import React from 'react'
import { SelectionCheckbox } from '../../../selection-checkbox'

/**
 * Props for the Card component
 */
export type CardProps = {
	/** The content to display inside the card */
	children: React.ReactNode
	/** Callback when the card selection is toggled */
	onSelect?: () => void
	/** Whether this card is currently selected */
	selected?: boolean
	/** Callback when the card body is clicked (opens profile) */
	onClick?: (e: React.MouseEvent) => void
	/** Whether this card is currently being dragged */
	isDragging?: boolean
	/** Accessible label for the selection checkbox */
	selectLabel: string
}

export function Card(
	{ children, onSelect, selected = false, onClick, isDragging = false, selectLabel }: CardProps,
) {
	return (
		<div
			className={ctl(`
				group bg-white border border-gray-200 rounded-md p-3.5 transition-all relative
				hover:shadow-md hover:border-blue-500
				${isDragging ? 'opacity-50 cursor-grabbing' : 'cursor-grab'}
				${selected ? 'ring-2 ring-purple-500 border-purple-400 bg-purple-50' : ''}
			`)}
			onClick={onClick}
		>
			{onSelect && (
				<div className="absolute top-3 left-3 z-10">
					<SelectionCheckbox
						checked={selected}
						onToggle={() => onSelect()}
						label={selectLabel}
					/>
				</div>
			)}
			<div className="min-w-0 pl-7">
				{children}
			</div>
		</div>
	)
}
